import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"
import { BOOKMARK_CHART_COLORS_REORDERED } from "../custom/bookmark_chart_colors"

export default class extends Controller {

  connect() {
    this.renderChart()
    this.element.chart = this.chart
  }

  renderChart() {
    const labels = JSON.parse(this.element.dataset.chartLabels)
    const values = JSON.parse(this.element.dataset.chartValues)
    const label = this.element.dataset.chartLabel

    const defaultColors = BOOKMARK_CHART_COLORS_REORDERED

    let colors = defaultColors;

    if (this.element.dataset.chartColors) {
      try {
        const parsedColors = JSON.parse(this.element.dataset.chartColors);

        if (Array.isArray(parsedColors) && parsedColors.length > 0) {
          colors = parsedColors;
        }
      } catch (e) {
        colors = defaultColors;
      }
    }

    if (this.chart) {
      this.chart.destroy()
    }
    const centerTextPlugin = {
      id: 'centerText',

      afterInit(chart) {
        const dataset = chart.data.datasets[0];

        chart.$total = dataset.data.reduce((a, b) => a + b, 0);
        chart.$activeIndex = null;
      },

      beforeUpdate(chart) {
        const dataset = chart.data.datasets[0];
        chart.$total = dataset.data.reduce((a, b) => a + b, 0);
      },

      beforeDraw(chart) {

        const { ctx, chartArea } = chart;

        if (!chartArea) return;

        const { left, right, top, bottom } = chartArea;

        const centerX = (left + right) / 2;
        const centerY = (top + bottom) / 2;

        const dataset = chart.data.datasets[0];
        const labels = chart.data.labels;

        const index = chart.$activeIndex;

        let label, value, percent;

        let lines;

        const meta = chart.getDatasetMeta(0);
        if (!meta.data.length) return;
        const doughnut = meta.data[0];
        const innerRadius = doughnut.innerRadius;
        const titleFontSize = innerRadius * 0.18;
        const valueFontSize = innerRadius * 0.5;
        const percentFontSize = innerRadius * 0.14;
        const sliceColor = dataset.backgroundColor[index];

        if (index !== null && index !== undefined) {
          value = dataset.data[index];
          label = labels[index];
          percent = (value / chart.$total) * 100;

          lines = [
            { text: label, size: `bold ${titleFontSize}px sans-serif`, color: sliceColor + "CC" },
            { text: value, size: `bold ${valueFontSize}px sans-serif`, color: sliceColor },
            { text: `${percent.toFixed(1)}%`, size: `${percentFontSize}px sans-serif`, color: sliceColor + "99" }
          ];
        } else {
          value = chart.$total;
          lines = [
            { text: value, size: `bold ${valueFontSize}px sans-serif`, color: "#666" }
            // ❌ pas de pourcentage ici
          ];
        }

        ctx.save();
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";

        const lineHeight = valueFontSize * 0.7;
        const offsetY = 0;
        // const startY = height / 2 - (lines.length - 1) * lineHeight / 2 + offsetY;
        const startY = centerY - ((lines.length - 1) * lineHeight) / 2 + offsetY;
        lines.forEach((line, i) => {
          ctx.font = line.size;
          ctx.fillStyle = line.color;
          ctx.fillText(line.text, centerX, startY + i * lineHeight);
        });

        ctx.restore();
      }
    };
    this.chart = new Chart(this.element, {
      type: this.element.dataset.chartGraph,
      data: {
        labels: labels,
        datasets: [{
          label: label,
          data: values,
          backgroundColor: colors
        }]
      },
      options: {
        responsive: true,
        onHover: (event, activeElements, chart) => {
          const index = activeElements.length ? activeElements[0].index : null;

          if (chart.$activeIndex !== index) {
            chart.$activeIndex = index;
            chart.draw(); // OK ici (PAS dans beforeDraw)
          }
        },
        plugins: {
          legend: {
            display: ["pie", "doughnut"].includes(this.element.dataset.chartGraph),
            position: 'top',
            labels: {
              boxWidth: 32,
              padding: 12
            }
          },
          tooltip: {
            callbacks: {
              title: () => null,
              label: (context) => {
                const value = context.raw;
                const dimension = context.dataset.label;
                const label = context.label;
                const chartType = context.chart.config.type;
                if (["pie", "doughnut"].includes(chartType)) {
                  const total = context.dataset.data.reduce((a, b) => a + b, 0);
                  const percent = ((value / total) * 100).toFixed(1);
                  return `${dimension} ${label} : ${value} (${percent}%)`;
                }
                return `${dimension} ${label} : ${value}`;
              }
            }
          }
        }
      },
      plugins: this.element.dataset.chartGraph === 'doughnut' ? [centerTextPlugin] : []
    })
  }
}
